import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  fetchGymSegmentMembersBPData,
  fetchGymSegmentMembersTrialData,
  fetchGymSegmentMembersUnassignedData,
} from "../../../../redux/prospect-reducers/prospectSlice";

export const useMemberPopoverData = (isOpen, popoverType, gymId, memberCount, filters, userInfoData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && gymId && filters && userInfoData?.token && memberCount > 0) {
      const baseFilters = {
        gym_id: gymId,
        start_date: filters.start_date || "",
        end_date: filters.end_date || "",
        checkin_time_filter: filters.checkin_time_filter || "",
        page: 0,
        limit: memberCount, // Fetch all members based on the count from the card
      };

      switch (popoverType) {
        case "unassigned":
          dispatch(
            fetchGymSegmentMembersUnassignedData({
              filters: {
                ...baseFilters,
                filter_type: "unassigned",
              },
              token: userInfoData.token,
            })
          );
          break;
        case "trial":
          dispatch(
            fetchGymSegmentMembersTrialData({
              filters: {
                ...baseFilters,
                filter_type: "pt_trial",
              },
              token: userInfoData.token,
            })
          );
          break;
        case "bca_pending":
          dispatch(
            fetchGymSegmentMembersBPData({
              filters: {
                ...baseFilters,
                filter_type: "bca_pending",
              },
              token: userInfoData.token,
            })
          );
          break;
        default:
          break;
      }
    }
  }, [isOpen, popoverType, gymId, memberCount, filters, userInfoData?.token, dispatch]);
};
